import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AnimatedLogo.scss';

const AnimatedLogo = ({ logoUrl, animationType = 'glitch' }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const getAnimationClass = () => {
    const baseClass = 'animated-logo';
    const classes = [baseClass, `${baseClass}--${animationType}`];

    if (isVisible) classes.push(`${baseClass}--visible`);
    if (isHovered) classes.push(`${baseClass}--hovered`);

    return classes.join(' ');
  };

  return (
    <Link
      className={getAnimationClass()}
      to="/"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="animated-logo__wrapper">
        {/* Main logo */}
        <img
          src={logoUrl}
          alt="Logo"
          className="animated-logo__img animated-logo__img--main"
        />

        {/* Glitch layers (only for glitch animation) */}
        {animationType === 'glitch' && (
          <>
            <img
              src={logoUrl}
              alt=""
              className="animated-logo__img animated-logo__img--glitch-1"
              aria-hidden="true"
            />
            <img
              src={logoUrl}
              alt=""
              className="animated-logo__img animated-logo__img--glitch-2"
              aria-hidden="true"
            />
          </>
        )}

        {/* Glow effect */}
        <div className="animated-logo__glow"></div>

        {/* Particles for hover effect */}
        {animationType === 'particles' && (
          <div className="animated-logo__particles">
            {[...Array(8)].map((_, i) => (
              <span key={i} className="animated-logo__particle"></span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default AnimatedLogo;
